import { render, staticRenderFns } from "./Receipt_Footer.vue?vue&type=template&id=11a91bfc&"
import script from "./Receipt_Footer.vue?vue&type=script&lang=js&"
export * from "./Receipt_Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports